import * as amplitude from '@amplitude/unified';
import type { ItemCategory } from '@/api/gen/itemCategory';
import { AnalyticsEvent } from '@/constants/analyticsEvents';
import { ActivityType } from '@/model/Activity/types';
import { TaskType } from '@/model/Task/types';
import { UserRole } from '@/model/User.model';

export const AmplitudeHelper = {
  trackUserSignedUp(params: { user_role?: UserRole; classroom_name: string; school_name: string }) {
    amplitude.track(AnalyticsEvent.UserSignedUp, params);
  },

  trackUserLoggedIn(params: { login_method: 'access_code' | 'email_password' | 'google'; user_role?: UserRole }) {
    amplitude.track(AnalyticsEvent.UserLoggedIn, params);
  },

  trackUserLoggedOut() {
    amplitude.track(AnalyticsEvent.UserLoggedOut);
  },

  trackAvatarPageViewed() {
    amplitude.track(AnalyticsEvent.AvatarPageViewed);
  },

  trackFreeAvatarItemEquipped(params: { item_id: string; item_category: ItemCategory }) {
    amplitude.track(AnalyticsEvent.FreeAvatarItemEquipped, params);
  },

  trackAvatarItemPurchased(params: { item_id: string; item_category: ItemCategory; item_price: number }) {
    amplitude.track(AnalyticsEvent.AvatarItemPurchased, params);
  },

  trackAvatarSelected(params: { items_changed: number; is_first_time: boolean }) {
    amplitude.track(AnalyticsEvent.AvatarSelected, params);
  },

  trackLessonStarted(params: {
    lesson_id: string;
    lesson_instance_id: string;
    lesson_title: string;
    classroom_id: string;
  }) {
    amplitude.track(AnalyticsEvent.LessonStarted, params);
  },

  trackLessonCompleted(params: {
    lesson_id: string;
    lesson_instance_id: string;
    lesson_title: string;
    classroom_id: string;
    lesson_score: number | null;
  }) {
    amplitude.track(AnalyticsEvent.LessonCompleted, params);
  },

  trackActivityStarted(params: {
    activity_id: string;
    activity_type?: ActivityType;
    lesson_instance_id: string;
    activity_instance_id: string;
  }) {
    amplitude.track(AnalyticsEvent.ActivityStarted, params);
  },

  trackActivityResumed(params: { activity_id: string; activity_type?: ActivityType; lesson_instance_id: string }) {
    amplitude.track(AnalyticsEvent.ActivityResumed, params);
  },

  trackActivityCompleted(params: {
    activity_instance_id: string;
    lesson_instance_id: string;
    activity_type: ActivityType;
  }) {
    amplitude.track(AnalyticsEvent.ActivityCompleted, params);
  },

  trackActivityReportViewed(params: {
    activity_id: string;
    activity_name: string;
    lesson_instance_id: string;
    activity_type: ActivityType;
  }) {
    amplitude.track(AnalyticsEvent.ActivityReportViewed, params);
  },

  trackTaskSubmitted(params: { task_id: string; task_type: TaskType; activity_instance_id: string }) {
    amplitude.track(AnalyticsEvent.TaskSubmitted, params);
  },

  trackLeaderboardViewed(params: { classroom_id: string }) {
    amplitude.track(AnalyticsEvent.LeaderboardViewed, params);
  },
};
